module.exports = ol.style.Style;